const getters = {
  selectedBrand(state, rootGetters) {
    return state[rootGetters.getBrandUnitIdVariables.brandId];
  },
};

export default getters;
